<section class="scr-page scr-page--compact">
  <div class="scr-card crm-list">
    <tp-page-header
      variant="toolbar"
      title="Tareas CRM"
      [subtitle]="loaded ? crmTaskList.length + (crmTaskList.length === 1 ? ' tarea pendiente de gestionar' : ' tareas pendientes de gestionar') : 'Cargando…'"
    ></tp-page-header>
    @if (loaded && crmTaskList.length === 0) {
      <tp-empty-state
        icon="assignment_turned_in"
        title="No hay tareas CRM pendientes"
        message="Cuando el CRM envíe una oportunidad para gestionar, va a aparecer en esta lista."
      ></tp-empty-state>
    }
    <mat-accordion class="task-list-accordion" displayMode="flat">
      @for (task of crmTaskList; track task) {
        <mat-expansion-panel hideToggle="true">
          <mat-expansion-panel-header>
            <div class="crm-item">
              <div class="crm-item__text">
                <h2 class="crm-item__client">{{ task.clientName }}</h2>
                <div class="crm-item__meta">
                  <span>Creada el {{ task.creationDate | date: 'dd/MM/yyyy' }}</span>
                  <span class="crm-item__sep" aria-hidden="true">·</span>
                  <span>Oportunidad #{{ task.opportunityId }}</span>
                </div>
              </div>
              <button (click)="$event.stopPropagation(); goToWorkloadStepTwo(task.opportunityId)" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" type="button" class="scr-btn-secondary" mat-stroked-button>
                Gestionar OT
              </button>
            </div>
          </mat-expansion-panel-header>
          <p class="crm-item__details">{{ task.details }}</p>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</section>
